import { createAsyncThunk } from '@reduxjs/toolkit';

import { getErrorMessage } from '@/shared/utils/error';

import { cumprimentoService } from './services';

export const buscarCumprimentoPorId = createAsyncThunk(
  'cumprimento/buscarPorId',
  async (id: string, { rejectWithValue }) => {
    try {
      return await cumprimentoService.buscarPorId(id);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const listarAtividades = createAsyncThunk(
  'cumprimento/listarAtividades',
  async (
    {
      execucaoId,
      filtros,
    }: {
      execucaoId: string;
      filtros?: {
        dataInicio?: string;
        dataFim?: string;
        origem?: string;
        tipo?: string;
      };
    },
    { rejectWithValue },
  ) => {
    try {
      return await cumprimentoService.listarAtividades(execucaoId, filtros);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const buscarTimeline = createAsyncThunk(
  'cumprimento/buscarTimeline',
  async (execucaoId: string, { rejectWithValue }) => {
    try {
      return await cumprimentoService.buscarTimeline(execucaoId);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const atualizarStatusCumprimento = createAsyncThunk(
  'cumprimento/atualizarStatus',
  async (
    {
      id,
      dados,
    }: {
      id: string;
      dados: {
        status: string;
        observacoes?: string;
      };
    },
    { rejectWithValue },
  ) => {
    try {
      return await cumprimentoService.atualizarStatus(id, dados);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const arquivarCumprimento = createAsyncThunk(
  'cumprimento/arquivar',
  async (
    {
      id,
      dados,
    }: {
      id: string;
      dados: {
        motivo: string;
        dataArquivamento: string;
        observacoes?: string;
      };
    },
    { rejectWithValue },
  ) => {
    try {
      await cumprimentoService.arquivar(id, dados);
      return id;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const listarAnotacoes = createAsyncThunk(
  'cumprimento/listarAnotacoes',
  async (execucaoId: string, { rejectWithValue }) => {
    try {
      return await cumprimentoService.listarAnotacoes(execucaoId);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const criarAnotacao = createAsyncThunk(
  'cumprimento/criarAnotacao',
  async (
    {
      execucaoId,
      dados,
    }: {
      execucaoId: string;
      dados: {
        texto: string;
        prazo?: string;
        responsavel?: string[];
        andamento?: string;
        prioridade?: 'alta' | 'media' | 'baixa';
      };
    },
    { rejectWithValue },
  ) => {
    try {
      return await cumprimentoService.criarAnotacao(execucaoId, dados);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const atualizarAnotacao = createAsyncThunk(
  'cumprimento/atualizarAnotacao',
  async (
    {
      anotacaoId,
      dados,
    }: {
      anotacaoId: string;
      dados: {
        texto: string;
        prazo?: string;
        responsavel?: string[];
        andamento?: string;
        prioridade?: 'alta' | 'media' | 'baixa';
        status?: 'ativa' | 'concluida' | 'cancelada';
      };
    },
    { rejectWithValue },
  ) => {
    try {
      return await cumprimentoService.atualizarAnotacao(anotacaoId, dados);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const excluirAnotacao = createAsyncThunk(
  'cumprimento/excluirAnotacao',
  async (anotacaoId: string, { rejectWithValue }) => {
    try {
      await cumprimentoService.excluirAnotacao(anotacaoId);
      return anotacaoId;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);
